<template lang="html">
    <div class="page" id="proLessons">
        <header class="pageHeader">
            <fade-image src="assets/headers/lessons.png" />
        </header>

        <div id="scroller" class="small">
            <div class="pageHeaderIntro">
                <h1>Lessons</h1>
                <img class="icon small" src="~@/assets/Lesson.svg" />
            </div>
            <h2 class="title" style="margin-bottom: 10px">Next Lesson:</h2>

            <next-lesson
                :pro="true"
                :lesson="next_lesson"
                :player="next_lesson.player"
                @bookingCancelled="getPastUpcomingLessons"
            />

            <router-link class="button dark" :to="{ name: 'proLessonBook' }">
                Book a lesson
                <chevron-right-icon class="icon" />
            </router-link>

            <router-link class="button dark" :to="{ name: 'proLessonDiary' }">
                Diary settings
                <chevron-right-icon class="icon" />
            </router-link>

            <router-link class="button dark mb20" :to="{ name: 'proLessonSettings' }">
                Lesson duration and pricing
                <chevron-right-icon class="icon" />
            </router-link>

            <br />

            <div v-if="datesLoaded">
                <upcoming-lesson-item
                    title="Todays bookings"
                    :dates="todaysLessons"
                    style="margin-bottom: 10px"
                />
                <br />
                <upcoming-lesson-item
                    style="margin-bottom10px"
                    title="Future bookings"
                    :dates="upComingLessons"
                />
            </div>
        </div>
    </div>
</template>

<script>
import UpcomingLessonItem from "@/components/Pro/Lessons/upcoming-lesson-item";
import FadeImage from "@/components/App/fade-image";
import { ChevronRightIcon } from "vue-feather-icons";
import NextLesson from "@/components/Pro/Next-lesson";

export default {
    name: "lessons",
    components: {
        UpcomingLessonItem,
        ChevronRightIcon,
        NextLesson,
        FadeImage,
    },
    computed: {
        lessons() {
            return this.$store.state.proLessons;
        },
        next_lesson() {
            var date = new Date();
            var closest = Infinity;
            var response = false;

            this.lessons.forEach((lesson) => {
                if (this.$date(lesson.date) >= date && this.$date(lesson.date) < closest) {
                    closest = this.$date(lesson.date);

                    if (!lesson.cancelled_at) {
                        response = lesson;
                    }
                }
            });
            return response;
            //return this.$store.state.user.next_lesson
        },
    },
    created() {
        this.$store.dispatch("getProLessons");
        this.getPastUpcomingLessons();
    },
    data() {
        return {
            todaysLessons: false,
            upComingLessons: false,
            datesLoaded: false,
        };
    },
    methods: {
        getPastUpcomingLessons() {
            window.axios.get("/lessons/past-upcoming").then((response) => {
                this.upComingLessons = response.data.upcoming;
                this.todaysLessons = response.data.todays;
                this.datesLoaded = true;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#proLessons {
    .pageHeaderIntro {
        .icon {
            width: auto;
            margin-top: -10px;
        }
    }
    .button {
        margin-bottom: 10px;
    }
    .title {
        margin-bottom: 20px;
    }

    .historyLesson {
        background: #eef5f2;
        border-radius: $radius;
        margin-bottom: 10px;
        padding: 17px 20px;
        position: relative;

        a {
            text-decoration: none;
            color: $green_0;
        }
        &.noRecord {
            background: $green_0;
            color: white;
            a {
                color: white;
            }
            strong {
                font-weight: 700;
                display: block;
                margin-top: 10px;
            }
        }
        b {
            font-weight: 700;
            margin-bottom: 10px;
            display: block;
        }
        .recordArrow {
            position: absolute;
            right: 15px;
            bottom: 20px;
            pointer-events: none;
        }
        .star {
            position: absolute;
            right: 35px;
            bottom: 15px;
            top: auto;
        }
    }
    .title {
        line-height: 1.5;
    }
}
</style>
